(function ($) {
    const anchorLinksContainer = document.getElementById('anchorLinks')

    if(anchorLinksContainer) {
        const links = Array.prototype.slice.call( anchorLinksContainer.querySelectorAll('li'), 0 )
        const tabs = document.getElementById('myTab');

        if(links.length > 0) {
            links.forEach((link) => {
                link.addEventListener('click', (e) => {
                    const selectedTab = e.target.getAttribute('data-id');
                    if(selectedTab) {
                        tabs.scrollIntoView({behavior: "smooth"});
                        $('#myTab a[href="' + selectedTab + '"]').tab('show')
                    }
                })
            })
        }
    } 
})(jQuery);
